import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';

function StartShoppingButton({ label, openModal }) {
    return (
        <div className="start-shopping-button">
            <Button onClick={() => {
                openModal({
                    layout: 'zip-form',
                });
            }} size="large" facet={['call-to-action', 'tertiary', 'onboarding']}>{label}</Button>
        </div>
    );
}


StartShoppingButton.propTypes = {
    openModal: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};

StartShoppingButton.defaultProps = {
    label: 'Lorem Ipsum',
};


export default connect(
    null,
    reduxUtils.mapDispatchToProps({
        openModal: 'modal.open',
    }),
)(StartShoppingButton);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/start-shopping-button/index.js